<template>
  <div class="login">
    <div class="dl">
      <a href="/"><img src="@/assets/images/logo_paijie.png"></a>
    </div>
    <div class="dl_bj">
      <div class="dl_main">
        <ul>
          <li class="dl_left">
            <a href="/"><img src="@/assets/images/cskj.png" width="420" height="240"></a>
          </li>
          <li class="dl_right">
            <div class="right-login">
              <div class="dl_right_tit">{{$t("register.welcome")}}</div>
              <div class="tips" v-if="errorShow">*{{ error }}</div>
              <div class="dlbd">
                <div class="res-item1">
                  <input type="text" :placeholder='$t("register.phone")' maxlength="11" class="input-item1" v-model="registerData.phone">
                  <i class="res-icon1">
                    <img src="@/assets/images/1.png" width="21" height="21">
                  </i>
                </div>
                <div class="res-item0">
                  <input type="password" :placeholder='$t("register.password")' class="input-item0" v-model="registerData.password">
                  <i class="res-icon1">
                    <img src="@/assets/images/3.png" width="21" height="21">
                  </i>
                </div>

                <!-- Agreement Section -->
                <div style="text-align: left; margin-top:15px; color: rgb(104, 104, 104);">
                  <span @click="addEvent" ref="Check" class="el-icon-full-screen"> &nbsp;&nbsp;请阅读并同意</span>&nbsp;
                  《<span @click="Platform"><a ref="span_check_1" style="text-decoration: underline; color: rgb(104, 104, 104);">拍界平台协议</a></span>》与
                  《<span @click="Privacy"><a ref="span_check" style="text-decoration: underline;line-height:40px; color: rgb(104, 104, 104);">拍界隐私协议</a></span>》
                </div>

                <div class="dl-btn1">
                  <button id="dl-btn" class="dl-btn dl-btn-block" @click="registerForm">{{$t("register.register")}}</button>
                </div>

                <div class="tab-login">
                  已有账号？<router-link to="/login" style="color: red;">立即登录</router-link>
                </div>
              </div>
            </div>
            <div class="right-ma">
              <img src="@/assets/images/ma.jpg">
              <div>扫码关注拍界平台</div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <!-- Privacy Agreement Dialog -->
    <el-dialog :visible.sync="dialogFormVisible1" :before-close="handleClose">
      <!-- Same privacy agreement content as in login -->
      <!-- ... -->
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handelClick1" style="width: 200px;font-size:16px;">已阅读</el-button>
      </div>
    </el-dialog>

    <!-- Platform Agreement Dialog -->
    <el-dialog :visible.sync="dialogFormVisible" :before-close="handleClose">
      <!-- Same platform agreement content as in login -->
      <!-- ... -->
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handelClick" style="width: 200px;font-size:16px;">已阅读</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import qs from 'qs'
export default {
  metaInfo: {
    title: "拍界注册——唤醒您的沉睡资产",
    meta: [{
      name: "keywords",
      content: "拍界注册,拍界官网,捡漏,拍卖,手机拍卖,二手设备拍卖"
    }, {
      name: "description",
      content: "拍界注册页面，加入拍界拍卖平台。拍界注册,拍界官网,捡漏,拍卖,手机拍卖,二手设备拍卖"
    }]
  },
  name: 'Register',
  data () {
    return {
      registerData: {
        phone: '',
        password: '',
        // confirmPassword: ''
      },
      errorShow: false,
      error: '',
      dialogFormVisible: false,
      dialogFormVisible1: false,
    }
  },
  created () {
    this.$emit('header', false);
    this.$emit('footer', false);
    this.$emit('shortcutOperation', false);
  },
  methods: {
    addEvent (e) {
      let check = "el-icon-full-screen";
      let no_check = "el-icon-check";

      if (e.target.className == no_check) {
        e.target.innerText = " 请阅读并同意";
        this.$refs.span_check_1.style.color = " rgb(104, 104, 104)";
        this.$refs.span_check.style.color = " rgb(104, 104, 104)";
        e.currentTarget.parentElement.style.color = " rgb(104, 104, 104)";
        event.currentTarget.className = "el-icon-full-screen"
      } else {
        e.target.innerText = " 已阅读并同意";
        this.$refs.span_check_1.style.color = "#FF0000";
        this.$refs.span_check.style.color = "#FF0000";
        e.currentTarget.parentElement.style.color = "#FF0000";
        event.currentTarget.className = "el-icon-check"
      }
    },
    Platform () {
      this.dialogFormVisible = true;
    },
    Privacy () {
      this.dialogFormVisible1 = true;
    },
    handleClose () {
      this.$router.go(-1);
    },
    handelClick () {
      this.dialogFormVisible = false;
    },
    handelClick1 () {
      this.dialogFormVisible1 = false;
    },
    registerForm () {
      const pattern = /0?(13|14|15|17|18|19)[0-9]{9}/;
      const Check = this.$refs.Check.className;

      // Check agreement
      if (Check == 'el-icon-full-screen') {
        this.$alert('请勾选相关协议！', '提示', {
          confirmButtonText: '确定'
        });
        return;
      }

      // Validate phone
      if (!this.registerData.phone || !pattern.test(this.registerData.phone)) {
        this.error = this.$t("register.phone_error");
        this.errorShow = true;
        return;
      }

      // Validate password
      if (!this.registerData.password) {
        this.error = this.$t("register.password_empty");
        this.errorShow = true;
        return;
      }

      // Check password length
      if (this.registerData.password.length < 6) {
        this.error = this.$t("register.password_length");
        this.errorShow = true;
        return;
      }

      // Check password match
      // if (this.registerData.password !== this.registerData.confirmPassword) {
      //   this.error = this.$t("register.password_mismatch");
      //   this.errorShow = true;
      //   return;
      // }

      // Prepare registration data
      const registerData = qs.stringify({
        phone: this.registerData.phone,
        password: this.registerData.password
      });

      // Submit registration
      this.axios.post(this.$global.apiUrl.register, registerData, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
        .then(response => {
          // 成功响应格式需与后端完全匹配
          if (response.data.error.code === 0) {
            // 1. 存储Token（与验证码登录逻辑一致）
            localStorage.setItem('apiToken', response.data.apiToken);

            // 2. 更新全局状态（根据你的项目实际调整）
            if (this.$store) {
              this.$store.commit('setUser', {
                token: response.data.apiToken,
                nickname: response.data.nickname
              });
            }

            // 3. 跳转到首页或来源页
            const redirect = this.$route.query.redirect || '/';
            this.$router.push(redirect);

            // 4. 轻量提示（可选）
            this.$message.success('注册成功');
          } else {
            // 显示后端返回的错误
            this.error = response.data.error.message;
            this.errorShow = true;
          }
        })
        .catch(error => {
          // 网络错误处理
          this.error = error.response?.data?.error?.message || '网络错误';
          this.errorShow = true;
        });
    }
  }
}
</script>

<style scoped>
/* Use the same styles as your login page */
.el-icon-check {
  color: red;
}
.el-icon-full-screen {
  color: rgb(104, 104, 104);
}
</style>